import { photoUrl } from "./assets";
import {
  photographyShowcaseHref,
  showcaseOgImageUrl,
  showcasePhotoSlug,
  slugifyShowcaseTitle,
} from "./showcaseUrls.js";

export {
  photographyShowcaseHref,
  showcaseOgImageUrl,
  showcasePhotoSlug,
  slugifyShowcaseTitle,
};

/**
 * Map a home hero photo API record to the showcase/lightbox Photo shape.
 *
 * @param {{ id: number | string, imageKey?: string, url?: string, title?: string, description?: string, keywords?: string[], focusX?: number, focusY?: number }} photo
 */
export function heroPhotoToShowcasePhoto(photo) {
  const title = photo.title || "";
  return {
    id: String(photo.id),
    src: photoUrl(photo),
    t: title || "Untitled",
    cap: title,
    kw: photo.keywords || [],
    desc: photo.description || "",
    focusX: typeof photo.focusX === "number" ? photo.focusX : 50,
    focusY: typeof photo.focusY === "number" ? photo.focusY : 50,
  };
}

/** @param {Array<{ id?: string }>} photos @param {string | null | undefined} photoId */
export function getShowcaseIndexByPhotoId(photos, photoId) {
  if (!photoId) {
    return -1;
  }
  return photos.findIndex((photo) => String(photo.id) === String(photoId));
}

/**
 * @param {{ id?: string, t?: string }} photo
 * @param {string | null | undefined} [photoSlug]
 */
export function isCanonicalShowcasePath(photo, photoSlug) {
  const canonicalSlug = showcasePhotoSlug(photo);
  if (!photoSlug) {
    return canonicalSlug === "photo" || canonicalSlug === "untitled";
  }
  return photoSlug === canonicalSlug;
}
